const loadingLabel = "Loading";
const enIE = {
  loadingLabel
};
export {
  enIE as default,
  loadingLabel
};
